// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1vPPR","unreadBadge":"styles_unreadBadge__1kShK","modalContent":"styles_modalContent__2kbq8","modal":"styles_modal__3Z363"};